// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-resource-effective-permisssions > .ant-select {
  width: 100%;
}
.ngw-resource-effective-permisssions table.pure-table {
  margin-top: 1em;
  width: 100%;
}
.ngw-resource-effective-permisssions table.pure-table tbody tr.permission td.label {
  padding-left: 3em;
}
.ngw-resource-effective-permisssions table.pure-table tbody tr.permission td.value {
  text-align: center;
}
.ngw-resource-effective-permisssions table.pure-table tbody tr.permission td.value.yes {
  color: var(--success);
}
.ngw-resource-effective-permisssions table.pure-table tbody tr.permission td.value.no {
  color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/effective-permissions/EffectivePermissions.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;AAAR;AAFA;EAMQ,eAAA;EACA,WAAA;AADR;AANA;EAWoB,iBAAA;AAFpB;AATA;EAcoB,kBAAA;AAFpB;AAIoB;EACI,qBAAA;AAFxB;AAIoB;EACI,oBAAA;AAFxB","sourcesContent":[".ngw-resource-effective-permisssions {\n    > .ant-select {\n        width: 100%;\n    }\n\n    table.pure-table {\n        margin-top: 1em;\n        width: 100%;\n        tbody {\n            tr.permission {\n                td.label {\n                    padding-left: 3em;\n                }\n                td.value {\n                    text-align: center;\n\n                    &.yes {\n                        color: var(--success);\n                    }\n                    &.no {\n                        color: var(--danger);\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
